document.addEventListener('DOMContentLoaded', function () {
  const headings = document.querySelectorAll('.mobile-acc-heading');

  function toggleAccordion(event) {
    const heading = event.currentTarget;
    const details = heading.closest('.footer-block').querySelector('.footer-block__details');

    // Close all other open accordions
    document.querySelectorAll('.footer-block__details').forEach((otherDetails) => {
      if (otherDetails !== details) {
        otherDetails.classList.remove('open');
        otherDetails.previousElementSibling.classList.remove('open'); // Remove 'open' from heading
      }
    });

    // Toggle the current accordion
    heading.classList.toggle('open');
    details.classList.toggle('open');
  }

  function enableAccordion() {
    if (window.innerWidth <= 768) {
      headings.forEach((heading) => {
        heading.addEventListener('click', toggleAccordion);
      });
    } else {
      headings.forEach((heading) => {
        heading.removeEventListener('click', toggleAccordion);
        heading.classList.remove('open');
        heading.closest('.footer-block').querySelector('.footer-block__details').classList.remove('open');
      });
    }
  }
  enableAccordion();
  window.addEventListener('resize', enableAccordion);

  
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".facets__disclosure").forEach((details) => {
        details.addEventListener("toggle", function () {
            if (this.open) {
                // Close other details elements
                document.querySelectorAll(".facets__disclosure").forEach((el) => {
                    if (el !== this) {
                        el.classList.remove("opening");
                        el.classList.add("closing");
                        el.removeAttribute("open"); // Ensure only one stays open
                    }
                });

                // Mark this one as opening
                this.classList.remove("closing");
                this.classList.add("opening");
            } else {
                // Check if at least one <details> is still open
                const anyOpen = document.querySelector(".facets__disclosure[open]");

                if (!anyOpen) {
                    // If none are open, remove "closing" from all
                    document.querySelectorAll(".facets__disclosure").forEach((el) => {
                        el.classList.remove("closing");
                    });
                }

                this.classList.remove("opening");
            }
        });
    });

    // Remove "closing" from all when clicking outside
    document.addEventListener("click", function (event) {
        if (!event.target.closest(".facets__disclosure")) {
            document.querySelectorAll(".facets__disclosure").forEach((el) => {
                el.classList.remove("closing", "opening");
                el.removeAttribute("open"); // Ensures all close when clicking outside
            });
        }
    });
});

// code for transparent header
document.addEventListener('DOMContentLoaded', () => {
  const request_page_type = document.body.getAttribute('data-template-name');
  if (request_page_type === 'index') {
    const megaMenus = document.querySelectorAll('.mega-menu');
    const menudrawer = document.querySelector('.menu-drawer-container');
    const headerWrapper = document.querySelector('.header-wrapper');
    const firstSection = document.querySelector('#MainContent section');

    // Check if any mega menu is open
    const isMegaMenuOpen = () => Array.from(megaMenus).some(menu => menu.hasAttribute('open'));

    // Check if the menu drawer is open (Shopify uses aria-expanded)
    const isMenuDrawerOpen = () => {
      const drawerToggle = document.querySelector('[aria-controls="menu-drawer"]');
      return drawerToggle && drawerToggle.getAttribute('aria-expanded') === 'true';
    };

    // Update header styling class based on menu and section visibility
    const updateHeaderStyle = () => {
      const isAnyMenuOpen = isMegaMenuOpen() || isMenuDrawerOpen();
      const isFirstSectionVisible = document.body.classList.contains('first-section-visible');

      if (isAnyMenuOpen && isFirstSectionVisible) {
        document.body.classList.add('menu-open-dark-on-light');
      } else {
        document.body.classList.remove('menu-open-dark-on-light');
      }
    };

    // Mutation Observer for mega menus
    megaMenus.forEach(menu => {
      const observer = new MutationObserver(updateHeaderStyle);
      observer.observe(menu, { attributes: true, attributeFilter: ['open'] });
    });

    // Mutation Observer for menu drawer (watching aria-expanded)
    const drawerToggle = document.querySelector('[aria-controls="menu-drawer"]');
    if (drawerToggle) {
      const drawerObserver = new MutationObserver(updateHeaderStyle);
      drawerObserver.observe(drawerToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    // Intersection Observer to detect if first section is in viewport
    if (firstSection) {
      const sectionObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            document.body.classList.add('first-section-visible');
          } else {
            document.body.classList.remove('first-section-visible');
          }
          updateHeaderStyle(); // run again on section visibility change
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      sectionObserver.observe(firstSection);
    }
  }
});
